(function ($) {
    $(function () {
        // how far the element should scroll when an arrow is clicked
        var SCROLL_PERCENTAGE = 0.7,
            FUDGE_AMOUNT = 80;

        $('.timeline-container').each(function () {
            var $container = $(this),
                $arrowNext = $container.find('.next-arrow'),
                $arrowPrev = $container.find('.prev-arrow'),
                $contentContainer = $container.find('.timeline-scroll-container'),
                $contentItems = $contentContainer.find('ul.timeline-list > li');

            var getContentWidth = function () {
                return $contentItems.outerWidth(true) * $contentItems.length;
            };

            var setArrowState = function (newScroll) {
                var contentWidth = getContentWidth(),
                    containerWidth = $container.width();

                if (((containerWidth + newScroll + FUDGE_AMOUNT) >= contentWidth) || (contentWidth <= containerWidth)) {
                    $arrowNext.addClass('arrow-hide');
                }
                else {
                    $arrowNext.removeClass('arrow-hide');
                }

                if (newScroll == 0 || contentWidth <= containerWidth) {
                    $arrowPrev.addClass('arrow-hide');
                }
                else {
                    $arrowPrev.removeClass('arrow-hide');
                }
            };

            var scrollTo = function (newScroll) {
                $contentContainer.animate({
                    scrollLeft: newScroll
                });
            };

            $arrowNext.on('click touchend', function () {
                var contentWidth = getContentWidth(),
                    containerWidth = $container.width(),
                    currentScroll = $contentContainer.scrollLeft(),
                    newScroll = Math.min(currentScroll + (containerWidth * SCROLL_PERCENTAGE), contentWidth - containerWidth);

                scrollTo(newScroll);
            });

            $arrowPrev.on('click touchend', function () {
                var contentWidth = getContentWidth(),
                    containerWidth = $container.width(),
                    currentScroll = $contentContainer.scrollLeft(),
                    newScroll = Math.max(0, currentScroll - (containerWidth * SCROLL_PERCENTAGE));

                scrollTo(newScroll);
            });

            $contentContainer.on('scroll', $.debounce(150, function () {
                setArrowState($contentContainer.scrollLeft());
            }));
        });
    });
})(jQuery);